import React, { useState } from 'react'
import PageStyle from "../../../Components/Layout/PageLayout";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import {
  useGetAllloatRequestsQuery,
} from "../../../../api/employeeFloat";
import { useNavigate } from "react-router";
import Pagination from "../../../Components/Pagination/Pagination";
import { TableActions } from "../../../Components/Misc/Actions";
import Table from "../../../Components/Table/Table";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { FilterByStatus } from '../../Employee/FloatRequest/data';

const purposes = [
  { label: "Business Development", value: 0 },
  { label: "Relationship Management", value: 1 },
];
const requestForOptions = [
  { label: "Self", value: 0 },
  { label: "Team", value: 1 },
];
const floatList = [
  {
    label: "Float Advance",
    value: 0,
  },
  {
    label: "Promotional Items",
    value: 1,
  },
  { label: "Perishables", value: 2 },
  {
    label: "Visitation",
    value: 3,
  },
];

const ManagementFloatRequest = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();
  const { data, isLoading } = useGetAllloatRequestsQuery({
    pageSize: pageSize,
    pageNumber: currentPage,
    searchText,
    filter,
    startDate,
    endDate,
  });
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.responseObject?.data?.length > 0 ? (
    data?.responseObject?.data?.map((item, index) => {

      return (
        <tr key={index}>
          <td>
            <input
              type="checkbox"
              style={{ accentColor: "#5A7B53" }}

            /></td>
          <td>{index + 1}</td>
          <td>{item?.requestorName}</td>
          <td>{purposes.filter((purpose) => purpose.value === item?.purpose)[0]?.label}</td>
          <td>{requestForOptions.filter((requestFor) => requestFor.value === item?.requestFor)[0]?.label}</td>
          <td>{item?.color}</td>
          <td>{item?.effectiveDate}</td>
          <td>{item?.noOfDays}</td>
          <td>{item?.floatTypes?.map((floatType) => floatList.find((float) => float.value === floatType)?.label).filter(Boolean).join(", ")}</td>
          <td>{FormatDateTime(item?.submittedDate)}</td>
          <td>{item?.status}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view`}>
              {[

                {
                  name: "View",
                  action: () => handleView(item.id),
                },

              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Status Label Found
      </td>
    </tr>
  );
  const actionButton = (
    <>
      <CTAButtons>
        Approve
      </CTAButtons>
    </>
  );
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  return (
    <PageStyle
      hasBack={false}
      demoTitle={"FLOAT REQUESTS"}
      hasTopPageDemo
    >
      <div className="flex justify-between items-center">
        <form className={DashboardStyle.dashboard_filter}>
          <SearchFilter
            value={searchText}
            text={(searchText) => setSearchText(searchText)}
          />
          <CalendarFilter2
            name="Select Date Range"
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            normalDate
          />
          <ProDropFilter
            filter={filter}
            setFilter={setFilter}
            name={"Status"}
            filterBy={FilterByStatus}
          />
        </form>
        <div>{actionButton}</div>
      </div>
      <Table>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                style={{ accentColor: "#5A7B53" }}
              />
            </th>
            <th>S/N</th>
            <th style={{ cursor: "pointer" }}>Request By</th>
            <th style={{ cursor: "pointer" }}>Purpose</th>
            <th style={{ cursor: "pointer" }}>Request For</th>
            <th>Color</th>
            <th style={{ cursor: "pointer" }}>Effective Date</th>
            <th style={{ cursor: "pointer" }}>No of Days</th>
            <th>Float Type</th>
            <th>Date Requested</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{tableContent}</tbody>
      </Table>
      <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.totalRows}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
    </PageStyle>
  )
}

export default ManagementFloatRequest